module.exports = __webpack_public_path__ + "docs/risks-4936aa.md";